import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Star, ChevronLeft, ChevronRight } from "lucide-react";

export default function ReviewsCarousel({ section, reviews = [] }) {
  const [idx, setIdx] = useState(0);
  if (!reviews.length) return null;
  const review = reviews[idx];
  const go = (d) => setIdx((i) => (i + d + reviews.length) % reviews.length);

  return (
    <section className="bg-parchment border-y border-brass/10" data-testid="reviews-section">
      <div className="mx-auto max-w-5xl px-6 sm:px-12 py-24 sm:py-32 text-center">
        <p className="text-xs uppercase font-mono tracking-[0.3em] text-gold">{section.eyebrow || "Google Reviews"}</p>
        <h2 className="mt-4 text-3xl sm:text-4xl font-serif font-semibold text-ink">{section.title}</h2>
        <div className="mt-6 flex justify-center gap-1" data-testid="reviews-stars">
          {[...Array(5)].map((_, i) => (
            <Star key={i} size={18} className="fill-brass text-gold" />
          ))}
        </div>
        <div className="relative mt-10 min-h-[180px]">
          <AnimatePresence mode="wait">
            <motion.blockquote
              key={idx}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.5 }}
              data-testid="review-card"
            >
              <p className="text-lg sm:text-xl font-serif italic text-ink2/90 leading-relaxed max-w-3xl mx-auto">"{review.text}"</p>
              <footer className="mt-6">
                <p className="text-sm font-semibold text-gold">{review.name}</p>
                <p className="text-xs font-mono text-ink2 mt-1">{review.date} — Google</p>
              </footer>
            </motion.blockquote>
          </AnimatePresence>
        </div>
        <div className="mt-10 flex items-center justify-center gap-4">
          <button onClick={() => go(-1)} data-testid="review-prev-button" aria-label="Previous review" className="rounded-full border border-brass/30 p-2.5 text-gold transition-colors hover:bg-brass hover:text-cast">
            <ChevronLeft size={18} />
          </button>
          <span className="text-xs font-mono text-ink2">{idx + 1} / {reviews.length}</span>
          <button onClick={() => go(1)} data-testid="review-next-button" aria-label="Next review" className="rounded-full border border-brass/30 p-2.5 text-gold transition-colors hover:bg-brass hover:text-cast">
            <ChevronRight size={18} />
          </button>
        </div>
      </div>
    </section>
  );
}
